"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const idm_classifier_service_client_js_1 = require("@synisys/idm-classifier-service-client-js");
const idm_dataset_service_client_js_1 = require("@synisys/idm-dataset-service-client-js");
const idm_filtering_controls_1 = require("@synisys/idm-filtering-controls");
const Observable_1 = require("rxjs/Observable");
const zip_1 = require("rxjs/observable/zip");
const operators_1 = require("rxjs/operators");
const Subject_1 = require("rxjs/Subject");
class ReportingCategoryValueLoader {
    constructor(classifierService, userService, authenticationService, meCategoriesCommonService, currentLanguageProvider, paths) {
        this.classifierService = classifierService;
        this.userService = userService;
        this.authenticationService = authenticationService;
        this.meCategoriesCommonService = meCategoriesCommonService;
        this.currentLanguageProvider = currentLanguageProvider;
        this.paths = paths;
        this.destroy$ = new Subject_1.Subject();
    }
    getCategoryValues(id, filterJson, pagingOptions, filterIds, searchValue) {
        let categorySystemName;
        let pathDto;
        pathDto = this.paths.get(id);
        categorySystemName = pathDto.metadata.get('filterCategory');
        if (pathDto instanceof idm_dataset_service_client_js_1.CategoryPathDto) {
            categorySystemName = pathDto.metaCategoryId.systemName;
            if (this.loadValuesFromME(pathDto.categoryType)) {
                return this.meCategoriesCommonService.getItemsBySystemName(categorySystemName)
                    .pipe(operators_1.takeUntil(this.destroy$), operators_1.map((items) => items.map(item => new idm_filtering_controls_1.CategoryValue(item.id, item.name))));
            }
        }
        if (categorySystemName) {
            if (filterIds && filterIds.length) {
                let classifiers;
                return this.classifierService.loadClassifiersByIds(categorySystemName, filterIds)
                    .pipe(operators_1.takeUntil(this.destroy$), operators_1.switchMap(data => {
                    classifiers = data.getData();
                    const classifierNames = classifiers.map(classifier => {
                        return this.classifierService.getEntityName(categorySystemName, classifier);
                    });
                    return zip_1.zip(...classifierNames);
                }), operators_1.map((classifierNames => {
                    return classifiers.map((classifier, index) => {
                        return new idm_filtering_controls_1.CategoryValue(classifier.getId(), classifierNames[index]);
                    });
                })));
            }
            if (categorySystemName === ReportingCategoryValueLoader.WF_STATE_CATEGORY_SYSTEM_NAME && pathDto.metadata.has('processId')) {
                const filter = new idm_classifier_service_client_js_1.FilterBuilder().is(ReportingCategoryValueLoader.WF_PROCESS_FIELD_SYSTEM_NAME, pathDto.metadata.get('processId')).buildJson();
                if (filterJson && pagingOptions) {
                    filterJson = new idm_classifier_service_client_js_1.FilterBuilder().and(filter).and(filterJson).buildJson();
                }
                else {
                    return this.classifierService.loadClassifiersViewByFilter(categorySystemName, filter)
                        .pipe(operators_1.takeUntil(this.destroy$), operators_1.map(classifiers => {
                        return classifiers.map(classifier => {
                            return new idm_filtering_controls_1.CategoryValue(classifier.getId(), classifier.getName());
                        });
                    }));
                }
            }
            if (filterJson && pagingOptions) {
                return this.classifierService.loadClassifiersViewByPaging(categorySystemName, filterJson, pagingOptions)
                    .pipe(operators_1.takeUntil(this.destroy$), operators_1.map(classifiers => {
                    return classifiers.map(classifier => {
                        return new idm_filtering_controls_1.CategoryValue(classifier.getId(), classifier.getName());
                    });
                }));
            }
            if (filterJson) {
                return this.classifierService.loadClassifiersViewByFilter(categorySystemName, filterJson)
                    .pipe(operators_1.takeUntil(this.destroy$), operators_1.map(classifiers => {
                    return classifiers.map(classifier => {
                        return new idm_filtering_controls_1.CategoryValue(classifier.getId(), classifier.getName());
                    });
                }));
            }
            return this.classifierService.loadClassifiersView(categorySystemName)
                .pipe(operators_1.takeUntil(this.destroy$), operators_1.map(classifiers => {
                return classifiers.map(classifier => {
                    return new idm_filtering_controls_1.CategoryValue(classifier.getId(), classifier.getName());
                });
            }));
        }
        return Observable_1.Observable.empty();
    }
    ngOnDestroy() {
        this.destroy$.next(true);
        this.destroy$.complete();
    }
    loadValuesFromME(categoryType) {
        return categoryType === idm_dataset_service_client_js_1.CategoryType.ME_ASSETS ||
            categoryType === idm_dataset_service_client_js_1.CategoryType.INDICATOR;
    }
    getCurrencies() {
        return this.classifierService.loadClassifiersView("currency")
            .pipe(operators_1.takeUntil(this.destroy$), operators_1.map(currencies => {
            return currencies.map(currency => {
                return new idm_filtering_controls_1.CurrencyValue(currency.getId(), currency.getName());
            });
        }));
    }
}
ReportingCategoryValueLoader.WF_STATE_CATEGORY_SYSTEM_NAME = 'WFState';
ReportingCategoryValueLoader.WF_PROCESS_FIELD_SYSTEM_NAME = 'WFProcessID';
exports.ReportingCategoryValueLoader = ReportingCategoryValueLoader;
//# sourceMappingURL=reporting-category-value-loader.js.map